export default function OverviewStatCard({
  title,
  value,
  subtitle,
  icon,
  iconBg = "bg-slate-100",
}) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>

          <h3 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">
            {value}
          </h3>

          {subtitle && (
            <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
          )}
        </div>

        <div
          className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${iconBg}`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
}
